// extracted by mini-css-extract-plugin
export default {"backLink":"LedgerDepositModal_backLink__01sw-"};